import { apiSlice } from './apiSlice'

/** One row of `tlc_factory.view_factory_sampling_psslable2` (Access record source
 *  for frmQualityPssLableSubForm). Only label-relevant fields are typed. */
export interface PssLabelRecord {
  sample_no: string | null
  client_lot_id: string | null
  contract_sale: string | null
  txtcontract: string | null
  consignee: string | null
  grade: string | null
  lot_size_mt: number | null
  delivery_to: string | null
  pss_terms: string | null
  sample_type: string | null
  quantity_pr: number | null
  unit_pr: string | null
  shipper_pr: string | null
  email_pr: string | null
}

/** Enriched Sample No picker option (Access cblotclient + contract/grade/lot). */
export interface PssSampleOption {
  sampleNo: string
  contractRef: string | null
  grade: string | null
  clientLotId: string | null
}

interface PrintPreviewArgs {
  sampleNo: string
  copies: number
}

export const qualityPssLabelApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPssSampleOptions: builder.query<PssSampleOption[], void>({
      query: () => '/quality/pss-label/sample-options',
      transformResponse: (resp: { data: PssSampleOption[] }) => resp.data ?? [],
    }),
    getPssLabelRecord: builder.query<PssLabelRecord, string>({
      query: (sampleNo) => `/quality/pss-label/record?sampleNo=${encodeURIComponent(sampleNo)}`,
      transformResponse: (resp: { data: PssLabelRecord }) => resp.data,
    }),
    getPssLabelPrintPreview: builder.query<
      { title: string; html: string; message?: string },
      PrintPreviewArgs
    >({
      query: ({ sampleNo, copies }) =>
        `/quality/pss-label/print/preview?sampleNo=${encodeURIComponent(sampleNo)}&copies=${copies}`,
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {
  useGetPssSampleOptionsQuery,
  useGetPssLabelRecordQuery,
  useLazyGetPssLabelPrintPreviewQuery,
} = qualityPssLabelApi
